module.exports = __webpack_public_path__ + "static/support.06048a50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/sponsorship/support.jpg
// module id = 500
// module chunks = 135625081114434